import { graphql } from "react-relay";

export const ACCOUNT_FRAGMENT = graphql`
	fragment editLeadStrategyForm_AccountFragment on Account {
		id
		extension(accountExtensionKind: Tka) {
			... on TkaAccountExtension {
				accountType
				domain
			}
		}
	}
`;

export const SET_ACCOUNT_TYPE_MUTATION = graphql`
	mutation editLeadStrategyForm_SetAccountTypeMutation($input: SetAccountTypeAndDomainInput!) {
		Admin {
			Auth {
				setAccountTypeAndDomain(input: $input) {
					account {
						id
					}
				}
			}
		}
	}
`;
